import React from 'react';

import { Box, Text } from '../../core';

export interface Props {
  /** Error message to display in red alert */
  errorMessage?: string;
  /** Success message to display in green alert */
  successMessage?: string;
}

const FormAlert = ({ errorMessage, successMessage }: Props): JSX.Element | null => {
  let feedbackMessage: string | undefined;
  if (errorMessage) {
    feedbackMessage = errorMessage;
  } else if (successMessage) {
    feedbackMessage = successMessage;
  }

  if (!feedbackMessage) return null;

  return (
    <Box
      background={errorMessage ? 'error' : 'success'}
      borderColor={errorMessage ? 'border.error' : 'border.success'}
      borderRadius="primary"
      borderStyle="solid"
      borderWidth="2px"
      mb="6x"
      p="4x"
    >
      <Text webProps={{ role: 'alert' }}>{feedbackMessage}</Text>
    </Box>
  );
};

/**
 * FormAlert displays error or success messages with appropriate styling and ARIA role.
 * Shows error messages with priority over success messages.
 */
export default FormAlert;
